/* NW-Upsell: PDP-Upsell, Markierung fuer die A/B-Tests 8 (PDP), 9 (Drawer), 11 (Ergaenzung) und Tracking (docs/UPSELL.md).

   - Zuteilung kommt aus snippets/nw-ab-upsell.liquid (window.nwUpAb): pdp neu/alt, drawer an/aus, erg an/aus.
   - Warenkorb-Attribute _ab_pdp_upsell / _ab_drawer_recs / _ab_pdp_erg / _ab_pdp_erg_sicht: Shopify uebernimmt sie in
     die Bestellung.
   - Ereignisse gehen gesammelt an den Sammelpunkt der NW-Upsell-App (window.nwUpEndpoint), aber nur,
     wenn der Besucher im Cookie-Banner Statistik erlaubt hat (Shopify Customer Privacy API).
     Ohne Entscheidung wird gewartet, ohne Erlaubnis verworfen.
   - Pruefen ohne Server: localStorage.setItem('nw_up_debug', '1') zeigt jedes Ereignis in der Konsole.

   Ereignisse (t): pv Produktseite · up_seen PDP-Upsell sichtbar · up_add / up_rm PDP-Upsell an/aus ·
   atc anderes Produkt in den Warenkorb · dr_seen Drawer-Empfehlungen sichtbar · dr_add Drawer-Upsell ·
   erg_seen Platz der Ergaenzungs-Karte gesehen · erg_add Ergaenzung hinzugefuegt · co Klick auf "Zur Kasse" */
(function () {
  var ab = window.nwUpAb || {};
  var END = window.nwUpEndpoint || '';
  var page = window.nwUpProduct || null;

  /* ---------- Tracking ---------- */
  var queue = [];
  var sid = '';
  try {
    sid = sessionStorage.getItem('nw_up_sid');
    if (!sid) {
      sid = Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
      sessionStorage.setItem('nw_up_sid', sid);
    }
  } catch (e) {}

  function consent() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return null;
    if (cp.analyticsProcessingAllowed()) return true;
    // Noch keine Entscheidung im Banner: warten
    if (typeof cp.currentVisitorConsent === 'function') {
      var c = cp.currentVisitorConsent() || {};
      if (c.analytics === '' || c.analytics === undefined) return null;
    }
    return false;
  }

  function flush() {
    if (!END || !queue.length) return;
    var ok = consent();
    if (ok === null) return;
    if (ok === false) { queue = []; return; }
    while (queue.length) {
      var body = JSON.stringify({ e: queue.splice(0, 40) });
      var sent = false;
      try { sent = navigator.sendBeacon && navigator.sendBeacon(END, new Blob([body], { type: 'text/plain' })); } catch (e) {}
      if (!sent) {
        try { fetch(END, { method: 'POST', body: body, keepalive: true, mode: 'no-cors' }); } catch (e) {}
      }
    }
  }

  var DEBUG = false;
  try { DEBUG = localStorage.getItem('nw_up_debug') === '1'; } catch (e) {}

  function track(t, d) {
    if (!END && !DEBUG) return;
    var e = {
      t: t, vid: ab.vid, sid: sid, pdp: ab.pdp, dr: ab.drawer, r: ab.r, rd: ab.rd,
      m: (window.Shopify && window.Shopify.country) || '', l: (window.Shopify && window.Shopify.locale) || '',
      ts: Date.now()
    };
    for (var k in d) if (Object.prototype.hasOwnProperty.call(d, k)) e[k] = d[k];
    if (DEBUG) console.log('[nw-upsell]', t, e);
    if (!END) return;
    queue.push(e);
    if (queue.length > 200) queue.splice(0, queue.length - 200);
    clearTimeout(track.t);
    track.t = setTimeout(flush, 3000);
  }
  window.nwUp = { track: track };

  if (END) {
    if (window.Shopify && !window.Shopify.customerPrivacy && window.Shopify.loadFeatures) {
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) flush(); });
      } catch (e) {}
    }
    document.addEventListener('visitorConsentCollected', function () { setTimeout(flush, 50); });
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(); });
    window.addEventListener('pagehide', flush);
  }

  /* ---------- Warenkorb-Attribute (Gruppe in jede Bestellung) ---------- */
  // Drawer: seit Testende (20.10.2026) zeigen alle die Leiste, die Bestellung traegt 'alle' statt einer Gruppe.
  // Test 11: Gruppe an/aus und ob der Platz der Ergaenzungs-Karte gesehen wurde (leer = Attribut entfaellt)
  var ATTR = { _ab_pdp_upsell: ab.pdp, _ab_drawer_recs: ab.drawerAttr || ab.drawer,
    _ab_pdp_erg: ab.erg || '', _ab_pdp_erg_sicht: ab.ergSicht ? '1' : '' };
  var confirmed = false, pending = null, firstCart = null;

  // Beim Laden fragen Markierung und PDP-Upsell denselben Warenkorb ab (eine Anfrage statt zwei)
  function cartOnLoad() {
    if (!firstCart) {
      firstCart = fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }
    return firstCart;
  }

  function ensureAttrs(fresh) {
    if (!ab.pdp) return Promise.resolve();
    if (pending) return pending;
    pending = (fresh ? fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }) : cartOnLoad())
      .then(function (cart) {
        if (!cart.item_count) return;
        var a = cart.attributes || {};
        if (Object.keys(ATTR).every(function (k) { return (a[k] || '') === ATTR[k]; })) { confirmed = true; return; }
        return origFetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: ATTR })
        }).then(function (r) { confirmed = r.ok; });
      })
      .catch(function () {})
      .then(function () { pending = null; });
    return pending;
  }

  // Fehlt die Markierung beim Klick auf "Zur Kasse" noch, wird sie zuerst gesetzt (max. 1,5 s)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[name="checkout"], a[href^="/checkout"]');
    if (!btn) return;
    if (btn.dataset.nwUpCo !== '1') { btn.dataset.nwUpCo = '1'; track('co', { p: page }); flush(); }
    if (confirmed || btn.dataset.nwUpGo === '1' || !ab.pdp) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    Promise.race([ensureAttrs(true), new Promise(function (r) { setTimeout(r, 1500); })]).then(function () {
      btn.dataset.nwUpGo = '1';
      btn.click();
    });
  }, true);

  /* ---------- Hinzufuegen erkennen (Kaufbutton, Kaching, Drawer) ---------- */
  function readItems(body) {
    try {
      if (typeof body === 'string') {
        if (body.charAt(0) === '{') {
          var o = JSON.parse(body);
          return o.items || [o];
        }
        body = new URLSearchParams(body);
      }
      if (body && typeof body.get === 'function') {
        return [{ id: body.get('id'), properties: { _nw_up: body.get('properties[_nw_up]') } }];
      }
    } catch (e) {}
    return [];
  }

  function afterAdd(body) {
    var items = readItems(body);
    var ours = items.some(function (i) { return i && i.properties && i.properties._nw_up; });
    // Die Versandversicherung legt der Drawer selbst dazu, das ist keine Kaufentscheidung
    var ins = document.querySelector('[data-insur-prodid]');
    var insId = ins ? String(ins.dataset.insurProdid) : '';
    var ids = items.map(function (i) { return i && i.id && String(i.id); }).filter(function (id) { return id && id !== insId; });
    // Ein Klick kann mehrere Anfragen ausloesen (Kaching-Bundle, Versicherung): als eine Aktion zaehlen
    var now = Date.now();
    if (!ours && ids.length && now - (afterAdd.last || 0) > 2500) {
      afterAdd.last = now;
      track('atc', { p: page, v: ids.slice(0, 5) });
      // Haekchen-Liste: angehakte Upsells kommen jetzt mit (nur Gruppe 'neu', dort ist die Liste sichtbar)
      if (typeof window.nwUpMitnehmen === 'function' && document.documentElement.classList.contains('nw-up-pdp-neu')) {
        window.nwUpMitnehmen();
      }
    }
    setTimeout(function () { ensureAttrs(true); }, 300);
  }

  var origFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var p = origFetch.apply(window, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
        var body = init && init.body;
        p.then(function (r) { if (r.ok) afterAdd(body); }).catch(function () {});
      }
    } catch (e) {}
    return p;
  };

  if (window.XMLHttpRequest) {
    var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._nwAdd = String(method).toUpperCase() === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(String(url));
      return xo.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      if (this._nwAdd) {
        var x = this;
        x.addEventListener('load', function () { if (x.status >= 200 && x.status < 300) afterAdd(body); });
      }
      return xs.apply(this, arguments);
    };
  }

  /* ---------- PDP-Upsell: Haekchen-Liste "Wird oft zusammen gekauft" ----------
     Angehakte Produkte kommen mit, sobald das Hauptprodukt erfolgreich im Warenkorb ist (afterAdd ruft
     window.nwUpMitnehmen). Bereits drin (auch nach Neuladen): Zeile zeigt "Im Warenkorb", Tippen nimmt es heraus. */
  function refreshCart() {
    if (typeof window.nwRefreshDrawer === 'function') return window.nwRefreshDrawer();
    return Promise.resolve();
  }

  function initPdp() {
    var box = document.querySelector('[data-nw-pdp-up]');
    if (page) track('pv', { el: box ? 1 : 0, ids: box ? Array.prototype.map.call(box.querySelectorAll('[data-up-id]'), function (i) { return i.dataset.upId; }) : [] });
    if (!box || box.dataset.nwBound) return;
    box.dataset.nwBound = '1';
    var src = box.dataset.productId;
    var items = Array.prototype.slice.call(box.querySelectorAll('.nw-pdp-up__item'));

    function chk(item) { return item.querySelector('.nw-pdp-up__chk'); }
    function angehakt(item) { return chk(item).getAttribute('aria-checked') === 'true'; }

    // Angehakt: Haekchen setzen und nur diese Zeile gruen markieren (kurzes Aufleuchten beim Anhaken)
    function haken(item, an) {
      chk(item).setAttribute('aria-checked', an ? 'true' : 'false');
      item.classList.toggle('is-checked', an);
      if (an) {
        item.classList.remove('is-glow');
        void item.offsetWidth;
        item.classList.add('is-glow');
      }
    }

    function setState(item, key) {
      item.dataset.lineKey = key || '';
      item.classList.toggle('is-added', !!key);
      chk(item).setAttribute('aria-checked', key ? 'true' : 'false');
      item.classList.toggle('is-checked', !!key);
      var ddb = item.querySelector('.nw-pdp-up__dd');
      if (ddb) ddb.disabled = !!key;
    }

    // Schon im Warenkorb (z. B. nach Neuladen)? Dann als "Im Warenkorb" zeigen
    cartOnLoad()
      .then(function (cart) {
        (cart.items || []).forEach(function (line) {
          var pr = line.properties || {};
          if (pr._nw_up !== 'pdp' || String(pr._nw_up_src) !== String(src)) return;
          items.forEach(function (item) { if (String(line.product_id) === item.dataset.upId) setState(item, line.key); });
        });
      })
      .catch(function () {});

    // Mit dem Hauptprodukt in den Warenkorb (wird nach dessen erfolgreichem Hinzufuegen aufgerufen)
    window.nwUpMitnehmen = function () {
      var offen = items.filter(function (i) { return angehakt(i) && !i.dataset.lineKey && !i.classList.contains('is-out'); });
      if (!offen.length) return;
      origFetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: offen.map(function (i) {
          return { id: i.dataset.variantId, quantity: 1, properties: { _nw_up: 'pdp', _nw_up_src: src } };
        }) })
      }).then(function (r) {
        if (!r.ok) throw new Error('add ' + r.status);
        return r.json();
      }).then(function (res) {
        var lines = res.items || [];
        offen.forEach(function (i) {
          var line = lines.filter(function (l) { return String(l.variant_id) === String(i.dataset.variantId); })[0];
          setState(i, line ? line.key : 'x');
          track('up_add', { p: page, u: i.dataset.upId, v: i.dataset.variantId, slot: +i.dataset.slot });
        });
        setTimeout(function () { ensureAttrs(true); }, 300);
        return refreshCart();
      }).catch(function (e) { console.error('NW-Upsell:', e); });
    };

    function umschalten(item) {
      if (item.classList.contains('is-out') || item.dataset.busy) return;
      var key = item.dataset.lineKey;
      if (!key) {
        haken(item, !angehakt(item));
        return;
      }
      // Liegt schon im Warenkorb: wieder herausnehmen
      item.dataset.busy = '1';
      origFetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function (r) {
        if (!r.ok) throw new Error('change ' + r.status);
        setState(item, '');
        track('up_rm', { p: page, u: item.dataset.upId, slot: +item.dataset.slot });
        return refreshCart();
      }).catch(function (e) { console.error('NW-Upsell:', e); })
        .then(function () { delete item.dataset.busy; });
    }

    items.forEach(function (item) {
      // Ganze Zeile antippbar, ausser Klappmenue
      item.addEventListener('click', function (e) {
        if (e.target.closest('.nw-pdp-up__ddw')) return;
        umschalten(item);
      });

      // Variante: eigenes Klappmenue, geht immer direkt unter dem Feld auf
      var variants = [];
      var varEl = item.querySelector('.nw-pdp-up__vars');
      if (varEl) {
        try { variants = JSON.parse(varEl.textContent) || []; } catch (e) { variants = []; }
      }
      var ddw = item.querySelector('.nw-pdp-up__ddw');
      var dd = item.querySelector('.nw-pdp-up__dd');
      var list = item.querySelector('.nw-pdp-up__list');
      var opts = list ? Array.prototype.slice.call(list.querySelectorAll('li')) : [];

      function zeige(v) {
        if (dd) dd.querySelector('.nw-pdp-up__ddv').textContent = v.title;
        opts.forEach(function (li) { li.setAttribute('aria-selected', String(li.dataset.id) === String(v.id) ? 'true' : 'false'); });
        item.dataset.variantId = v.id;
        item.dataset.cents = v.cents;
        item.classList.toggle('is-out', !v.available);
        chk(item).disabled = !v.available;
        if (!v.available && !item.dataset.lineKey) haken(item, false);
        item.querySelector('.nw-pdp-up__now').textContent = v.available ? '+' + v.price : box.dataset.tSold;
        var was = item.querySelector('.nw-pdp-up__was');
        was.textContent = v.available && v.was ? v.was : '';
        was.hidden = !(v.available && v.was);
        if (v.img) item.querySelector('.nw-pdp-up__img img').src = v.img;
      }

      function auf(offen) {
        if (!list) return;
        list.hidden = !offen;
        dd.setAttribute('aria-expanded', offen ? 'true' : 'false');
        if (!offen) return;
        // nie ueber den rechten Bildschirmrand hinaus
        list.style.maxWidth = Math.max(160, Math.min(280, window.innerWidth - dd.getBoundingClientRect().left - 12)) + 'px';
        var aktiv = list.querySelector('[aria-selected="true"]') || opts[0];
        if (aktiv) aktiv.focus({ preventScroll: true });
        list.scrollIntoView({ block: 'nearest' });
      }

      function waehlen(li) {
        if (!li || li.getAttribute('aria-disabled') === 'true') return;
        var v = variants.filter(function (x) { return String(x.id) === li.dataset.id; })[0];
        if (v) zeige(v);
        auf(false);
        dd.focus();
      }

      if (dd && list) {
        dd.addEventListener('click', function () { auf(list.hidden); });
        dd.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); auf(true); }
        });
        opts.forEach(function (li, i) {
          li.addEventListener('click', function () { waehlen(li); });
          li.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
              e.preventDefault();
              var n = opts[i + (e.key === 'ArrowDown' ? 1 : -1)];
              if (n) n.focus();
            } else if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              waehlen(li);
            } else if (e.key === 'Escape' || e.key === 'Tab') {
              auf(false);
              if (e.key === 'Escape') dd.focus();
            }
          });
        });
        document.addEventListener('click', function (e) {
          if (!list.hidden && !ddw.contains(e.target)) auf(false);
        });
        var start = variants.filter(function (x) { return String(x.id) === String(item.dataset.variantId); })[0];
        if (start) zeige(start);
      }
    });

    if ('IntersectionObserver' in window && document.documentElement.classList.contains('nw-up-pdp-neu')) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) {
          io.disconnect();
          track('up_seen', { p: page, ids: items.map(function (i) { return i.dataset.upId; }) });
        }
      }, { threshold: 0.5 });
      io.observe(box);
    }
  }

  /* ---------- Drawer: Empfehlungen gesehen ---------- */
  function initDrawer() {
    var el = document.querySelector('cart-drawer');
    if (!el || !('MutationObserver' in window)) return;
    var open = false;
    new MutationObserver(function () {
      var now = el.classList.contains('active');
      if (now && !open) {
        setTimeout(function () {
          var wrap = document.querySelector('#CartDrawer .nw-upsell-main');
          if (!wrap || !wrap.offsetParent) return;
          var cards = wrap.querySelectorAll('.upsell-container .upsell-cartItem');
          if (!cards.length) return;
          var srcs = {};
          Array.prototype.forEach.call(cards, function (c) { var s = c.dataset.nwSrc || 'fallback'; srcs[s] = (srcs[s] || 0) + 1; });
          track('dr_seen', { p: page, n: cards.length, src: srcs,
            ids: Array.prototype.slice.call(cards, 0, 10).map(function (c) { return c.dataset.productId; }) });
        }, 900);
      }
      open = now;
    }).observe(el, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- Test 11: Ergaenzungs-Karte unter dem Kaufbereich (snippets/nw-ergaenzung-karte.liquid) ----------
     Platz seit 30.10.2026 (Wunsch des Betreibers, vorher direkt unter den Zahlungs-Icons): unter den Vertrauens-Kacheln
     und der Box "Aktualisierung vom ... / nur noch wenige Stueck" (nw-pdp-aktualisierung bzw. Block mit nw-update-card).
     Ohne diese Box unter den Kacheln, ohne Kacheln unter den Zahlungs-Icons. Icons und Kacheln setzt eine App beim Laden
     hinter das Produktformular, daher nach "load" noch einmal. Zu sehen ist die Karte nur in Gruppe 'an'; der
     Platzhalter davor zaehlt in beiden Gruppen als "gesehen" (_ab_pdp_erg_sicht).
     Hinzufuegen legt die Ergaenzung mit _nw_up = 'erg' in den Warenkorb, ohne ihn zu oeffnen. */
  function initErg() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-nw-erg]'), function (box) {
      if (box.dataset.nwBound) return;
      box.dataset.nwBound = '1';

      var info = box.closest('.product__info-container') || box.parentElement;
      function setzen() {
        var ziel = null;
        var pay = info.querySelector('.ss-payment-list');
        if (pay) {
          var hinten = Array.prototype.filter.call(pay.parentElement.children, function (k) {
            return k === pay || String(k.className).indexOf('ss_trust_badges') > -1;
          });
          ziel = hinten[hinten.length - 1];
        }
        // Box mit Lager-Hinweis: der Block direkt im Info-Bereich, sofern er nach dem Kaufbereich kommt
        var lager = info.querySelectorAll('.nw-aktuell, .nw-update-card');
        var kauf = pay || info.querySelector('product-form, form[action*="/cart/add"]');
        if (lager.length && kauf) {
          var block = lager[lager.length - 1];
          while (block.parentElement && block.parentElement !== info) block = block.parentElement;
          if (block.parentElement === info && (kauf.compareDocumentPosition(block) & Node.DOCUMENT_POSITION_FOLLOWING)) ziel = block;
        }
        if (ziel && ziel.nextElementSibling !== box) ziel.insertAdjacentElement('afterend', box);
      }
      setzen();
      window.addEventListener('load', setzen);

      var platz = box.querySelector('.nw-erg__platz');
      if (!ab.ergSicht && platz && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          if (!es.some(function (e) { return e.isIntersecting; })) return;
          io.disconnect();
          ab.ergSicht = 1;
          try { localStorage.setItem('nw_ab_up', JSON.stringify(ab)); } catch (e) {}
          ATTR._ab_pdp_erg_sicht = '1';
          confirmed = false;
          track('erg_seen', { p: page, g: ab.erg, u: box.dataset.erg });
          (pending || Promise.resolve()).then(function () { ensureAttrs(true); });
        });
        io.observe(platz);
      }

      var btn = box.querySelector('.nw-erg__btn');
      if (!btn) return;
      var label = btn.querySelector('span');
      var knopf = label.textContent;
      var fehler = box.querySelector('.nw-erg__fehler');
      var varianten = [];
      try { varianten = JSON.parse(box.querySelector('[data-nw-erg-varianten]').textContent); } catch (e) {}

      function drin(an) {
        btn.classList.toggle('is-drin', an);
        label.textContent = an ? btn.dataset.drin : knopf;
      }
      function waehlen(id) {
        var v = varianten.filter(function (x) { return String(x.id) === String(id); })[0];
        if (!v) return;
        if (btn.dataset.variant !== String(v.id)) drin(false);
        btn.dataset.variant = v.id;
        box.querySelector('[data-preis]').textContent = v.p;
        var statt = box.querySelector('[data-statt]');
        if (statt) { statt.textContent = v.c || ''; statt.hidden = !v.c; }
        Array.prototype.forEach.call(box.querySelectorAll('.nw-erg__var'), function (b) {
          var an = b.dataset.variant === String(v.id);
          b.classList.toggle('is-an', an);
          b.setAttribute('aria-pressed', an ? 'true' : 'false');
        });
        var sel = box.querySelector('.nw-erg__sel');
        if (sel) sel.value = String(v.id);
      }

      box.addEventListener('click', function (e) {
        var b = e.target.closest('.nw-erg__var');
        if (b && !b.disabled) waehlen(b.dataset.variant);
      });
      var sel = box.querySelector('.nw-erg__sel');
      if (sel) sel.addEventListener('change', function () { waehlen(sel.value); });

      // Schon im Warenkorb (z. B. nach Neuladen)? Dann diese Variante zeigen, Knopf auf "Im Warenkorb"
      cartOnLoad()
        .then(function (cart) {
          (cart.items || []).forEach(function (l) {
            var pr = l.properties || {};
            if (pr._nw_up === 'erg' && String(pr._nw_up_src) === box.dataset.src && String(l.product_id) === box.dataset.erg) {
              waehlen(l.variant_id);
              drin(true);
            }
          });
        })
        .catch(function () {});

      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-drin') || btn.getAttribute('aria-busy') === 'true') return;
        btn.setAttribute('aria-busy', 'true');
        if (fehler) fehler.hidden = true;
        origFetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: +btn.dataset.variant, quantity: 1,
            properties: { _nw_up: 'erg', _nw_up_src: box.dataset.src } }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add ' + r.status);
          drin(true);
          track('erg_add', { p: page, u: box.dataset.erg, v: btn.dataset.variant });
          confirmed = false;
          setTimeout(function () { ensureAttrs(true); }, 300);
          return refreshCart();
        }).catch(function (e) {
          if (fehler) fehler.hidden = false;
          console.error('NW-Upsell:', e);
        }).then(function () { btn.removeAttribute('aria-busy'); });
      });
    });
  }

  function init() { initPdp(); initDrawer(); initErg(); ensureAttrs(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
